module.exports = __webpack_public_path__ + "media/images/arrows/left-cd16a2bf8bdb305981387809917a2faa.svg";